type LabelledSeries = {
	name: string;
	label?: string;
};

/**
 * The current design-system chart API derives visible text from `series.name`.
 * Adapt a presentation-only copy so aliases render while upstream statistics
 * continue using the original stable series keys.
 */
export const applyChartSeriesDisplayNames = <
	TSeries extends LabelledSeries,
	TChart extends { series?: TSeries[] },
>(
	chartData: TChart,
): TChart => {
	if (!chartData.series?.some((series) => series.label?.trim())) return chartData;

	return {
		...chartData,
		series: chartData.series.map((series) => {
			const label = series.label?.trim();
			return label ? { ...series, name: label } : series;
		}),
	} as TChart;
};
